import sourceLocale from 'antd/lib/locale/en_US'

import { merge } from 'lodash'

const en_US = merge({}, sourceLocale, {
  Table: {
    loadingDescription: 'loading...',
    emptyDescription: 'No data',
  },
  Empty: {
    noGraphData: 'No graph data available',
    noPermission: 'No permission',
    createdSuccessfully: 'Created successfully',
    creationFailed: 'Creation failed',
    noNetwork: 'Network not connected',
    noData: 'No data available',
  },
  Handle: {
    more: 'More',
  },
  Exception: {
    '403': "Sorry, we don't have access to this page",
    '404': 'Sorry, there are no results on this page',
    '500': "I'm sorry, the server reported an error",
  },
  TntdCascader: {
    noDate: 'no date',
  },
  TntdSecondPage: {
    back: 'Back',
  },
  ColorPicker: {},
})

export default en_US
